// src/hooks/notifications/useNotifications.ts

import { useEffect, useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import {
  fetchNotifications,
  fetchUnreadCount,
  markAllRead,
  markRead,
} from "../../redux/notifications/notificationsSlice";
import {
  selectNotifications,
  selectNotificationsUnread,
  selectNotificationsLoading,
  selectNotificationsWsBound,
} from "../../redux/selectors/notifications/notificationsSelectors";

// Single interface for Notification screens/badge/dropdown
export function useNotifications(token?: string | null) {
  const dispatch = useAppDispatch();
  const items = useAppSelector(selectNotifications);
  const unread = useAppSelector(selectNotificationsUnread);
  const loading = useAppSelector(selectNotificationsLoading);
  const wsBound = useAppSelector(selectNotificationsWsBound);

  // Init WS + fetch initial data
  useEffect(() => {
    if (!token) return;
    dispatch(fetchNotifications());
    dispatch(fetchUnreadCount());
  }, [token, dispatch]);

  // Actions
  const markOneAsRead = useCallback((id: number) => {
    dispatch(markRead(id));
  }, [dispatch]);

  const markAllAsRead = useCallback(() => {
    dispatch(markAllRead());
  }, [dispatch]);

  // expose api to UI
  return {
    items,
    unread,
    loading,
    wsBound,
    markOneAsRead,
    markAllAsRead,
    refresh: () => {
      dispatch(fetchNotifications());
      dispatch(fetchUnreadCount());
    },
  };
}
